import { useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { chartByAppAnalyticsConfig } from './PartnerReports.events';
import useQueryParamsUpdate from './ReportsFilters/useQueryParamsUpdate';

/*
 * This function is used in all the Reports which has charts.
 * One row in a table represents one individual app.
 * On row click this function will update the query params accordingly.
 */
export const useRowClick = (partnerId, reportName) => {
  const {
    updateQueryParams
  } = useQueryParamsUpdate(partnerId, reportName);
  const fireAnalyticsEvent = useAnalyticsEvents();
  const rowClick = (event, appKey) => {
    var _event$target;
    // In case of anchor links, links to should take precedence
    if (event.target instanceof HTMLElement && ((_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.nodeName) === 'A') {
      return event.preventDefault();
    }
    fireAnalyticsEvent(chartByAppAnalyticsConfig({
      partnerId,
      reportName,
      queryParam: 'appkey',
      appKey: appKey !== null && appKey !== void 0 ? appKey : ''
    }));
    updateQueryParams({
      selectedOptionValue: appKey ? appKey : [],
      selectedOptionQueryParam: 'addon',
      shouldAppendUrl: false
    });
  };
  return {
    rowClick
  };
};